// extracted by mini-css-extract-plugin
module.exports = {"title":"AddUserModal_title__byDpA","dialog":"AddUserModal_dialog__2elB7","warning":"AddUserModal_warning__3aRiP"};